'use es6';

import { fromJS } from 'immutable';
import { serializableError } from '../utils/utils';
import ActionTypes from './ActionTypes';
import { getRecommendations as getRecommendationsQuery, getRecommendationsTopicPreference } from 'LearningCenterUI/features/recommendations';
export const getRecommendations = () => {
  return dispatch => {
    dispatch({
      type: ActionTypes.RECOMMENDATIONS_REQUESTING
    });
    const promise = getRecommendationsQuery().then(res => dispatch({
      type: ActionTypes.RECOMMENDATIONS_RECEIVED,
      payload: fromJS(res)
    }), err => dispatch({
      type: ActionTypes.RECOMMENDATIONS_ERROR,
      payload: serializableError(err)
    }));
    promise.catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
    return promise;
  };
};
export const getTopicPreferences = () => {
  return dispatch => {
    dispatch({
      type: ActionTypes.TOPIC_PREFERENCES_REQUESTING
    });
    const promise = getRecommendationsTopicPreference().then(res => dispatch({
      type: ActionTypes.TOPIC_PREFERENCES_RECEIVED,
      payload: fromJS(res)
    }), err => dispatch({
      type: ActionTypes.TOPIC_PREFERENCES_ERROR,
      payload: serializableError(err)
    }));
    promise.catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
    return promise;
  };
};